import {
  type FilterObject,
  isAndCondition,
  isOrCondition,
} from '@moment/trading-types/filter-expression'

/**
 * Extracts all field names from a FilterObject
 * Recursively processes 'and' and 'or' conditions
 * @param filter - The filter object to extract fields from
 * @returns Array of unique field names
 */
export function extractFieldsFromFilter(filter: FilterObject): string[] {
  const fields: Set<string> = new Set()

  function processFilter(filterObj: FilterObject) {
    // Recurse into structural operators
    if (isOrCondition(filterObj)) {
      filterObj.or.forEach(processFilter)
    }
    if (isAndCondition(filterObj)) {
      filterObj.and.forEach(processFilter)
    }

    // Always extract direct field keys (excluding structural operators)
    Object.keys(filterObj).forEach((key) => {
      if (key !== 'or' && key !== 'and' && key !== 'not') {
        fields.add(key)
      }
    })
  }

  processFilter(filter)
  return Array.from(fields)
}
